import React from "react";

const AdminTable = ({ tableHeaders = [], tableData = [] }) => {
  if (!Array.isArray(tableHeaders) || tableHeaders.length === 0) {
    return <div>No columns defined</div>;
  }

  return (
    <div className="w-full overflow-x-auto rounded-xl">
      <table className="w-full min-w-[980px] border-separate border-spacing-0 text-sm">
        <thead>
          <tr className="bg-slate-100">
            {tableHeaders.map((col) => (
              <th
                key={col.accessor || col.Header}
                className="border border-slate-200 px-4 py-3 text-left font-semibold text-slate-700"
              >
                {col.Header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {tableData.map((row, rowIndex) => (
            <tr
              key={row.id || rowIndex}
              className={`${rowIndex % 2 === 0 ? "bg-white" : "bg-slate-50/40"} hover:bg-slate-50`}
            >
              {tableHeaders.map((col) => {
                const value = col.accessor ? row[col.accessor] : "";
                const Cell = col.Cell;
                return (
                  <td
                    key={`${rowIndex}-${col.accessor || col.Header}`}
                    className="border border-slate-200 px-4 py-3 align-middle"
                  >
                    {Cell ? <Cell value={value} row={{ original: row }} /> : value ?? "-"}
                  </td>
                );
              })}
            </tr>
          ))}
          {tableData.length === 0 && (
            <tr>
              <td
                colSpan={tableHeaders.length}
                className="border border-slate-200 px-4 py-8 text-center text-slate-500"
              >
                No data available
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default AdminTable;
